import { ProductComponent, ComponentIds } from '@inter-ikea-core/core';
import { ProductType } from '@inter-ikea-storageone/range';
import { BestaFrameLegsFeatureSystem } from '@inter-ikea-storageone/range-besta';
import { BehaviorParameters } from 'rangeConfig/@types';

const autoFillLegsWithSupport = ({ coreApi, props }: BehaviorParameters) => {
  const legs = coreApi.entities.getByProductType(ProductType.BESTA_LEG);
  const selectedEntity = coreApi.entities.findSelectedEntity();
  const selectedEntityIsFrame = !!selectedEntity?.hasComponent(ComponentIds.FRAME_COMPONENT_ID);
  if (legs.length > 0) {
    const selectedLegProductRef =
      legs[0].getComponent<ProductComponent>(ComponentIds.PRODUCT_COMPONENT_ID)?.productRef || '';
    if (selectedLegProductRef === props.coreProductId) {
      coreApi
        .getSystem<BestaFrameLegsFeatureSystem>('BestaFrameLegsFeatureSystem')
        ?.changeSupportLeg(selectedLegProductRef, false, selectedEntityIsFrame);
    } else {
      coreApi
        .getSystem<BestaFrameLegsFeatureSystem>('BestaFrameLegsFeatureSystem')
        ?.changeSupportLeg(selectedLegProductRef, true, selectedEntityIsFrame);
    }
  }
  if (!selectedEntityIsFrame) {
    const legs = coreApi.entities.getByProductType(ProductType.BESTA_LEG);
    legs.length > 0 && coreApi.entities.select(legs[0]);
  }
};

export default autoFillLegsWithSupport;
